export const JOURNEY_STEP_KIND = Object.freeze({
  identity: "identity",
  profile: "profile",
  matchedTreatments: "matched_treatments",
  screeningIntro: "screening_intro",
  question: "question",
  consent: "consent",
  products: "products",
  labs: "labs",
  checkout: "checkout",
  completion: "completion",
});

export const JOURNEY_CONTEXT_LABEL = Object.freeze({
  authorization: "Authorize payment",
  consent: "Review and consent",
  match: "Your match",
  welcomePrefix: "Welcome to",
});

export const JOURNEY_BOUNDARY_MODE = Object.freeze({
  live: "live",
  preview: "preview",
});

export const JOURNEY_BOUNDARY_ERROR = Object.freeze({
  liveResolverRequired: "journey_live_resolver_required",
  previewEffectForbidden: "journey_preview_effect_forbidden",
});

export const JOURNEY_PROTECTED_EFFECT = Object.freeze({
  completion: "completion",
  identityLookupOrCreate: "identity_lookup_or_create",
  labOrder: "lab_order",
  notification: "notification",
  order: "order",
  patientProfile: "patient_profile",
  payment: "payment",
  providerDispatch: "provider_dispatch",
  reimbursement: "reimbursement",
});

export const JOURNEY_PREVIEW_KIND = Object.freeze({
  capability: "capability",
  simulator: "simulator",
});

export const JOURNEY_PREVIEW_FRAGMENT = Object.freeze({
  capability: "preview_capability",
  snapshotChecksum: "preview_snapshot_checksum",
  snapshotId: "preview_snapshot_id",
});

export const JOURNEY_PREVIEW_ERROR = Object.freeze({
  snapshotMismatch: "preview_snapshot_mismatch",
});

export const JOURNEY_MACHINE_EVENT = Object.freeze({
  rebase: "rebase",
  navigate: "navigate",
  back: "back",
  fail: "fail",
  retry: "retry",
});

export const JOURNEY_MACHINE_STATUS = Object.freeze({
  ready: "ready",
  error: "error",
});

export const JOURNEY_PROJECTION_ERROR = Object.freeze({
  duplicateItemId: "journey_item_id_duplicate",
  missingItemId: "journey_item_id_missing",
});

export const JOURNEY_SUPPORTED_QUESTION_TYPES = Object.freeze([
  "allergies",
  "bmi",
  "checkout",
  "consent",
  "date",
  "email",
  "file_upload",
  "height_weight",
  "labs",
  "matched_program_selection",
  "medical_conditions",
  "medication_dose_selector",
  "multiple_choice",
  "number",
  "patient_authentication",
  "personal_details",
  "phone",
  "product_selection",
  "program_authentication_preview",
  "program_lab_checkout",
  "self_reported_meds",
  "sex",
  "shipping_address",
  "single_choice",
  "state",
  "state_routing",
  "text",
  "textarea",
  "treatment_screening_intro",
  "zip",
]);

export const TREATMENT_PREVIEW_SOURCE = Object.freeze({
  admin: "admin",
});
